import { useInfiniteListController } from 'react-admin';
import { AVATARS } from '@/utils/CONST';

interface Props {
    type: string;
    enabled: boolean;
    filter?: object;
}

const useGetInfiniteAvatar = ({ type, enabled, filter }: Props) => {
    const {
        refetch,
        data,
        isLoading,
        fetchNextPage,
        // total,
        hasNextPage,
        isFetchingNextPage,
    } = useInfiniteListController({
        queryOptions: { enabled },
        resource: AVATARS,
        sort: {
            field: 'creationDate',
            order: 'ASC',
        },
        // perPage: 5,
        filter: {
            'metadataAvatarType.name': type,
            enabled: true,
            serialization_groups: ['read_avatar_parent'],
            ...filter,
        },
    });

    return { refetch, data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage };
};

export default useGetInfiniteAvatar;
